export default (state = null, { type, payload }) => {
    switch (type) {
        case 'SET_MAP_CENTER_REFERENCE':
            return payload
        case 'SET_MAP_CENTER_NULL':
            return null
        default:
            return state
    }
}